import React, { FC } from 'react';
import cn from 'classnames';
import parseClassnames from '../../../helpers/parseClassnames';
import Text from '../../../Text';
import { DialogContentProps } from '../../types';

export interface MainTitleProps
  extends Pick<DialogContentProps, 'type' | 'mainTitle' | 'dark'> {
  hasMoreElements?: boolean;
}

const MainTitle: FC<MainTitleProps> = ({
  type = 'm',
  mainTitle,
  dark,
  hasMoreElements,
}) => {
  const classes = hasMoreElements
    ? cn('block text-center mb-16', {
        'sm:mb-24': type === 'm' || type === 'full',
      })
    : 'block text-center';

  if (typeof mainTitle === 'string') {
    return (
      <Text
        className={classes}
        type={type === 's' ? 'h3' : 'h2'}
        responsive="sm"
        color={dark ? 'white' : 'base-main'}
      >
        {mainTitle}
      </Text>
    );
  }

  const mainTitleElement = mainTitle as React.ReactElement<any>;

  return React.cloneElement(mainTitleElement, {
    className: parseClassnames(mainTitleElement.props.className || '', classes),
  });
};

export default MainTitle;
